<template>
	<div>
		<i  @click="navTo" style="cursor: pointer;" class="el-icon-user"></i>
	</div>
</template>

<script>
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				
			}
		},
		methods:{
			navTo() {
				if(this.type == 'design') {
					return
				}
				this.$router.push({
					path:'/account'
				})
				// window.location.reload()
			}
		}
	}
</script>

<style>
</style>